import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Spin, Carousel } from 'antd';
import WonderGameSlider from '../components/WonderGameSlider';
import Loader from '../components/Loader';
import GutenContent from '../components/GutenContent';
import FeaturedProgramCard from '../components/FeaturedProgramCard';

const YanchaSurvey = () => {
    const [aboutpagedata, setAboutpagedata] = useState([])
    const [loading, setLoading] = useState(false)

    const kidsSurvey = () => {
        // console.log(link)
        // navigate(link)
        window.location.href = "https://www.yancha.in/survey-signup";
        setLoading(true);
    }

    const teensSurvey = () => {
        // console.log(link)
        // navigate(link)
        window.location.href = "https://www.yanchateens.com/survey-signup";
        setLoading(true);
    }

    return (
        <div>
            {
                loading ? <Loader /> :
                    <>
                        {/* <div className='spacer'>
                            <p className='large-gradient-heading brand-text'>The Yancha Power Parent Survey</p>
                        </div> */}

                        <div className='flex flex-col spacer gap-3 content-around'>
                            <button className='bg-white border-2 border-grey-300 p-[20px] rounded' onClick={() => kidsSurvey()}>
                                <div>
                                    <div className='flex flex-col items-center bottom15px'>
                                        <img src={require('../assets/yancha_logo.png')} width={150} alt="yancha_kids_logo" />
                                    </div>
                                    <div>
                                        <p className='text-center gradient-small brand-font'>The Yancha Power Parent Survey</p>
                                    </div>
                                </div>
                            </button>

                            <button className='bg-white border-2 border-grey-300 p-[20px] rounded' onClick={() => teensSurvey()}>
                                <div>
                                    <div className='flex flex-col items-center bottom15px'>
                                        <img src={require('../assets/yanda_teen_logo.png')} width={150} alt="yancha_kids_logo" />
                                    </div>
                                    <div>
                                        <p className='text-center gradient-small brand-font'>Teens Future Success Survey - Nudging Towards Excellence</p>
                                    </div>
                                </div>
                            </button>
                        </div>

                        {/* <div className="bottom15px">
                            <p className='brand-text gradient-heading'>
                                Discover yourself, as you evolve with your child
                            </p>
                        </div> */}

                        {/* <div className='spacer'>
                            <p className='brand-text txt bottom15px'>
                                The Yancha Power Parenting survey provides you with an immersive look into yourself to align your beliefs, thoughts, behaviors and actions. In this five minutes, simple thought provoking questions will help you identify your orientation towards parenting.
                            </p>
                            <p className='brand-text txt bottom15px'>
                                We ask for your email address to create an account so you can save your progress as you go through the Yancha Program. We do not share our email lists and your progress is private and confidential.
                            </p>
                            <p className='brand-text txt-heading font-bold bottom7px'>
                                Why take the Survey ?
                            </p>
                            <p className='brand-text txt'>
                                This survey helps you understand your approach to parenting and how you are evolving yourself in the process. A good parent is one who can help the child develop to reach his or her potential. Research shows that good parents able to:
                            </p>
                            <ul>
                                <li>✨ Develop healthier relationships</li>
                                <li>✨ Bring out the best in a child</li>
                                <li>✨ Provide unconditional love</li>
                                <li>✨ Become a happy and satisfied individual</li>
                            </ul>
                        </div> */}
                    </>
            }

        </div >
    )
}

export default YanchaSurvey